export default {
  'dna-collection-kit': [
    {
   name: 'How To Take Your EndoDNA Sample',
   src: 'https://player.vimeo.com/video/455945368'
  },
    {
   name: 'How To Register on MyDNA.live',
   src: 'https://player.vimeo.com/video/455944868'
  }
],
  'raw-data': [
    {
    name: 'How to Upload Raw Data',
    src: 'https://player.vimeo.com/video/455945133'
  },
  {
    name: 'How To Register on MyDNA.live',
    src: 'https://player.vimeo.com/video/455944868'
  }
]
};
